export const glacierDoughnutChartColors = ['#4f6d9f', '#213455', '#d7dce5ff', '#2e8ed3'];
export const alexForbesDoughnutChartColors = ['#15808D', '#124E57', '#E7F2F3', '#163338ff'];
export const glacierBarChartColors = {
  primary: '#4f6d9f',
  secondary: '#cfd8e6ff',
  error: '#c91400'
};

export const alexForbesBarChartColors = {
  primary: '#15808D',
  secondary: '#E7F2F3',
  error: '#A5242F'
};

export const alexForbesCategoricalColours = [
  '#003E7B',
  '#1469A8',
  '#2E90D5',
  '#5FA8D3',
  '#2E8E71',
  '#52B895',
  '#A8D5B8',
  '#FFA500',
  '#FF8C42',
  '#D2691E'
];
